import classNames from 'classnames';
import React, { FC } from 'react';
import styles from './PrequalProgressBar.module.scss';

type PrequalProgressBarStepPosition = 'start' | 'middle' | 'end';

type PrequalProgressBarStepStatus = 'pending' | 'current' | 'done';

export type PrequalProgressBarStepProps = {
  isLabelActive: boolean;
  isLeftBarActive: boolean;
  isRightBarActive: boolean;
  label: string;
  position: PrequalProgressBarStepPosition;
  shouldShowBarToTheLeft: boolean;
  shouldShowBarToTheRight: boolean;
  shouldShowInnerCircle: boolean;
  status: PrequalProgressBarStepStatus;
};

const PrequalProgressBarStep: FC<PrequalProgressBarStepProps> = ({
  isLabelActive,
  isLeftBarActive,
  isRightBarActive,
  label,
  shouldShowBarToTheLeft,
  shouldShowBarToTheRight,
  shouldShowInnerCircle,
  status,
}) => (
  <div className={styles.prequalProgressBarStep}>
    <div className={styles.prequalProgressBarStep__progressContainer}>
      <div
        className={classNames(
          styles.prequalProgressBarStep__bar,
          !shouldShowBarToTheLeft && styles['prequalProgressBarStep__bar--hidden'],
          isLeftBarActive && styles['prequalProgressBarStep__bar--active']
        )}
      />

      <div
        className={classNames(
          styles.prequalProgressBarStep__center,
          styles[`prequalProgressBarStep__center--${status}`]
        )}
      >
        {shouldShowInnerCircle && <div className={styles.prequalProgressBarStep__innerCircle} />}
      </div>

      <div
        className={classNames(
          styles.prequalProgressBarStep__bar,
          !shouldShowBarToTheRight && styles['prequalProgressBarStep__bar--hidden'],
          isRightBarActive && styles['prequalProgressBarStep__bar--active']
        )}
      />
    </div>
    <div className={styles.prequalProgressBarStep__labelContainer}>
      <span
        className={classNames(
          styles.prequalProgressBar__label,
          isLabelActive && styles['prequalProgressBarStep__label--active']
        )}
      >
        {label}
      </span>
    </div>
  </div>
);

export default PrequalProgressBarStep;
